import type { KitGroup, WizardLine } from '../types/wizard';
import { effectiveWhQty, type KitBomItem } from './kitQuantities';

/** Warehouse / BOM qty for a component line (kit-aware). */
export function componentRequiredQty(
  line: WizardLine,
  kitGroups: KitGroup[],
  kitIndex: number,
  bom: KitBomItem[] | null
): number {
  if (line.isKitHeader) return line.quantity;
  if (kitGroups.length > 0) return effectiveWhQty(line, kitGroups, kitIndex, bom);
  return line.quantity;
}

/** Manual non-scan qty, or auto (required − scanned tags) when null. */
export function effectiveNonScanQty(line: WizardLine, required: number): number {
  if (line.nonScanQty != null) {
    return Math.max(0, Math.min(line.nonScanQty, Math.max(0, required - line.scanQty)));
  }
  return Math.max(0, required - line.scanQty);
}

export function lineFilledQty(line: WizardLine, required: number): number {
  return line.scanQty + effectiveNonScanQty(line, required);
}

export function componentQtyFields(line: WizardLine, quantityField: number) {
  const scanQty = line.scanQty;
  if (!line.scannable) {
    return {
      dispRecQty: quantityField,
      scanQty: 0,
      nonScanQty: quantityField,
    };
  }
  const nonScanQty = effectiveNonScanQty(line, quantityField);
  const dispRecQty = scanQty + nonScanQty;
  return { dispRecQty, scanQty, nonScanQty };
}

export function clampManualNonScanLines(
  lines: WizardLine[],
  kitGroups: KitGroup[],
  bom: KitBomItem[] | null
): WizardLine[] {
  return lines.map((line) => {
    if (line.isKitHeader || line.nonScanQty == null) return line;
    const kitIndex =
      kitGroups.length > 0
        ? Math.max(
            0,
            kitGroups.findIndex((g) => g.lines.some((l) => l.id === line.id))
          )
        : 0;
    const required = componentRequiredQty(line, kitGroups, kitIndex, bom);
    const max = Math.max(0, required - line.scanQty);
    if (line.nonScanQty <= max) return line;
    return { ...line, nonScanQty: max };
  });
}
